import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {routePath, sep} from 'sdv-common';
import {DealsComponent} from './deals/deals.component';
import {ForbiddenComponent} from './forbidden/forbidden.component';
import {HomeComponent} from './home/home.component';
import {MainComponent} from './main/main.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {OoopsComponent} from './ooops/ooops.component';
import {ProfileComponent} from './profile/profile.component';
import {debugging} from './shared/constants';
import {SignInComponent} from './sign-in/sign-in.component';
import {SignUpComponent} from './sign-up/sign-up.component';
import {UserComponent} from './user/user.component';
import {SuccessfulComponent} from "./successful/successful.component";
import {TokensComponent} from "./tokens/tokens.component";
import {OverviewComponent} from "./overview/overview.component";

const authRoutes = [
  {
    path: routePath.login,
    component: SignInComponent
  },
  {
    path: routePath.registration,
    component: SignUpComponent
  }
];

const mainRoutes = [
  {
    path: routePath.copyright,
    loadChildren: () => import('./copyright/copyright.module').then(m => m.CopyrightModule)
  },
  {
    path: routePath.cookie,
    loadChildren: () => import('./cookie/cookie.module').then(m => m.CookieModule)
  },
  {
    path: routePath.termsAndConditions,
    loadChildren: () => import('./terms-and-conditions/terms-and-conditions.module').then(m => m.TermsAndConditionsModule)
  },
  {
    path: routePath.privacy,
    loadChildren: () => import('./privacy/privacy.module').then(m => m.PrivacyModule)
  },
  {
    path: routePath.disclaimer,
    loadChildren: () => import('./disclaimer/disclaimer.module').then(m => m.DisclaimerModule)
  },
  {
    path: routePath.consent,
    loadChildren: () => import('./consent/consent.module').then(m => m.ConsentModule)
  }
];

const serviceRoutes = [
  {
    path: routePath.notFound,
    component: NotFoundComponent
  },
  {
    path: routePath.accessDenied,
    component: ForbiddenComponent
  },
  {
    path: routePath.internalError,
    component: OoopsComponent
  },
  {
    path: 'successful',
    component: SuccessfulComponent
  }
];

const routes: Routes = [
  ...authRoutes,
  {
    pathMatch: 'full',
    path: routePath.root,
    redirectTo: ({queryParams}) => {
      if (Object.keys(queryParams).length === 0) {
        return sep + 'home' ;
      }
      return sep + 'home?' + new URLSearchParams(queryParams || {}).toString();
    }
  },
  {
    path: routePath.home,
    component: HomeComponent
  },
  {
    path: routePath.root,
    component: MainComponent,
    children: [
      ...mainRoutes,
      ...serviceRoutes,
      {
        path: routePath.root,
        component: OverviewComponent
      },
      {
        path: 'users',
        component: UserComponent
      },
      {
        path: 'deals',
        component: DealsComponent
      },
      {
        path: 'tokens',
        component: TokensComponent
      },
      {
        path: routePath.profile,
        component: ProfileComponent
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot([
      ...routes,
      {
        path: routePath.all,
        redirectTo: sep + routePath.notFound
      }
    ], {
      enableTracing: debugging
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
